import { render, staticRenderFns } from "./OpenOrder.vue?vue&type=template&id=16c61ce0&scoped=true&lang=pug&"
import script from "./OpenOrder.vue?vue&type=script&lang=js&"
export * from "./OpenOrder.vue?vue&type=script&lang=js&"
import style0 from "./OpenOrder.vue?vue&type=style&index=0&id=16c61ce0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c61ce0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
